'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { ForgotPasswordForm } from '@/components/ForgotPasswordForm/ForgotPasswordForm';
import LoginWrapper from '../Login/LoginWrapper';

export type HeroProps = {
  imageSrc: string;
  imageAlt?: string;
  titleLines?: string[];
};

export default function ForgotPassword() {
  const t = useTranslations('Login');

  return (
    <LoginWrapper
      heading={t('Forgot your password?')}
      subtitle={t('We will send a link to your email to reset your password')}
    >
      <ForgotPasswordForm />
    </LoginWrapper>
  );
}
